import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=c53c66d0&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c53c66d0')) {
      api.createRecord('c53c66d0', component.options)
    } else {
      api.reload('c53c66d0', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=c53c66d0&", function () {
      api.rerender('c53c66d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/globals/Modal.vue"
export default component.exports